import { createSlice, SerializedError } from '@reduxjs/toolkit';

import { Basket, BasketTrackingData } from 'src/types';
import { logger } from 'src/utils/serverLogger';
import { addItemToBasket, getBasketWithOptions, updateItem } from './thunks';

export interface BasketState {
  basket: Basket;
  trackingData: BasketTrackingData | null;
  error: SerializedError | null;
  isPending: boolean;
}

export const initialState: Readonly<BasketState> = {
  basket: { items: [] },
  trackingData: null,
  error: null,
  isPending: false,
};

export const { actions, reducer } = createSlice({
  name: 'basket',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addItemToBasket.pending, (state) => {
        state.error = null;
        state.isPending = true;
      })
      .addCase(addItemToBasket.fulfilled, (state, { payload }) => {
        const {
          data: {
            addItem: { basket, trackingData },
          },
        } = payload;

        state.basket.itemsCount = basket.itemsCount;
        state.basket.itemsTotal = basket.itemsTotal;
        state.trackingData = trackingData;
        state.error = null;
        state.isPending = false;
      })
      .addCase(addItemToBasket.rejected, (state, action) => {
        logger.error('Error adding item to basket', action.error);

        state.error = action.error;
        state.isPending = false;
      })
      .addCase(updateItem.pending, (state) => {
        state.error = null;
        state.isPending = true;
      })
      .addCase(updateItem.fulfilled, (state) => {
        state.error = null;
        state.isPending = false;
      })
      .addCase(updateItem.rejected, (state, action) => {
        logger.error('Error updating item in basket', action.error);

        state.error = action.error;
        state.isPending = false;
      })
      .addCase(getBasketWithOptions.fulfilled, (state, { payload }) => {
        state.basket.items = payload.data.basket.items;
        state.isPending = false;
      });
  },
});
